import { useCallback } from 'react';

import MaterieelDetailsPanel from '@/components/detailPanel/materieelDetails/MaterieelDetailsPanel';
import { useMaterieelEigenschappen } from '@/components/detailPanel/materieelDetails/useMaterieelEigenschappen';
import useTripleClick from '@/hooks/useTripleClick';
import useDefecten from '@/state/selectors/useDefecten';
import useClientState from '@/state/useClientState';

export default function MaterieelPanel() {
  const hideDetailPanel = useClientState((state) => state.hideDetailPanel);
  const deeltraject = useClientState((state) => state.mwdDeeltraject);
  const setShowDetailPanel = useClientState((state) => state.setShowDetailPanel);
  const { eigenschappen, materieelPanelData } = useMaterieelEigenschappen();

  const handleMaterieelTypeClick = useTripleClick(
    useCallback(() => {
      // CustomEvent acts as a lightweight pub/sub bus — the trigger fires and forgets, the listener picks it up. No shared state, no coupling, no
      // re-renders.
      globalThis.dispatchEvent(
        new CustomEvent('trainEasterEgg', {
          detail: {
            eenheidNummer: materieelPanelData?.nummer,
            materieelType: materieelPanelData?.materieelType,
          },
        }),
      );
    }, [materieelPanelData?.nummer, materieelPanelData?.materieelType]),
  );

  const { defectenView } = useDefecten(
    materieelPanelData?.nummer ? [materieelPanelData?.nummer] : null,
    ['DEFECT_NIET_INZETBAAR', 'BEPERKING_IN_TREINDIENST', 'GEEN_BEPERKINGEN'],
    {
      geefAlleenDefectenTerugTotEindeBijsturingsPeriode: true,
      geefAlleenNietGereedGemeldeDecten: false,
      sorteerOpTijd: true,
    },
  );

  // Zowel de defectenlijst als de defect-gestuurde pill-logica werken alleen met open werkorders.
  const defecten = defectenView.filter(
    (defect) => defect.eenheidNummer === materieelPanelData?.nummer && !defect.gereedgemeld,
  );

  const handleBackButtonClick = () => {
    if (deeltraject) {
      setShowDetailPanel(deeltraject);
    }
  };

  return (
    <MaterieelDetailsPanel
      materieelPanelData={materieelPanelData}
      eigenschappen={eigenschappen}
      defecten={defecten}
      onClose={hideDetailPanel}
      onBack={deeltraject ? handleBackButtonClick : undefined}
      onMaterieelTypeClick={handleMaterieelTypeClick}
    />
  );
}
